import { apiSlice } from './apiSlice';

export interface VehicleProfile {
  id: number;
  name: string;
  category: string;
  bodyType: string;
  lengthM?: number;
  widthM?: number;
  heightM?: number;
  deckHeightM?: number;
  axleCount?: number;
  maxAxleLoadT?: number;
  grossWeightT?: number;
  payloadT?: number;
  features?: any;
}

export interface CargoLayout {
  id: number;
  applicationId?: number;
  routeId?: number;
  vehicleProfileId?: number;
  vehicleSnapshot?: any;
  inputPayload?: any;
  resultPayload?: any;
  status: string;
  createdAt?: string;
}

export const calculationsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleProfiles: builder.query<VehicleProfile[], void>({
      query: () => ({ url: '/calculations/vehicle-profiles' }),
      transformResponse: (res: any) => res.data || [],
      providesTags: ['Calculations'] as any,
    }),
    createLayout: builder.mutation<CargoLayout, Partial<CargoLayout> & { applicationId?: number; routeId?: number; vehicleProfileId?: number; inputPayload?: any; }>({
      query: (body: any) => ({ url: '/calculations/layouts', method: 'POST', body }),
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['Calculations'] as any,
    }),
    getLayoutById: builder.query<CargoLayout, number>({
      query: (id: number) => ({ url: `/calculations/layouts/${id}` }),
      transformResponse: (res: any) => res.data,
      providesTags: ['Calculations'] as any,
    }),
    getLayouts: builder.query<{ items: CargoLayout[]; total: number; page: number; limit: number }, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 20 } = {}) => ({ url: `/calculations/layouts?page=${page}&limit=${limit}` }),
      transformResponse: (res: any) => res.data,
      providesTags: ['Calculations'] as any,
    }),
    updateLayout: builder.mutation<CargoLayout, { id: number; body: Partial<CargoLayout> & { vehicleProfileId?: number } }>({
      query: ({ id, body }) => ({ url: `/calculations/layouts/${id}`, method: 'PUT', body }),
      transformResponse: (res: any) => res.data,
      invalidatesTags: ['Calculations'] as any,
    }),
  }),
});

export const { useGetVehicleProfilesQuery, useCreateLayoutMutation, useGetLayoutByIdQuery, useGetLayoutsQuery, useUpdateLayoutMutation } = calculationsApi;


